// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	PrintButton: 'print-button',
	PdfButton: 'pdf-button',
	OpenInWordButton: 'open-in-word-button',
} as const;
